import React,{useEffect} from "react";
import Gallery from "./Gallery";
import People from "./People";
import Venue from "./Venue";
import Footer from "../pages/Footer";
import HomepageHappening from "./HomepageHappening";
import $ from "jquery";

const Homepage = (props) => {
  let t = null;
  let mt = null;
  // useEffect(() => {
  //     $('.imageAccordingItem').click(function() {
  //       if(t){
  //         clearTimeout(t)
  //         t = null
  //       }
  //       t = setTimeout(() => {
  //         $('.imageAccordingItem').removeClass('move').removeClass('active').removeClass('other')
  //         $('.zincGroup').removeClass('active')
  //       },5000)

  //       if($(this).hasClass("active")){
  //         $(this).addClass('move').removeClass('active').siblings().removeClass('other')
  //         $('.zincGroup').removeClass('active')
  //         if(mt){
  //           clearTimeout(mt)
  //           mt = null
  //         }
  //         mt = setTimeout(() => {
  //           $(this).removeClass('move')
  //         },1000)
  //       }else{
  //         $(this).removeClass('move').addClass('active').siblings().addClass('other')
  //         $('.zincGroup').addClass('active')
  //       }
  //     })
  // },[])

  $(window).ready(() => {

  // 
  // $('.imageAccordingItem').mouseleave(function() {
  //   if($(this).hasClass("active"))
  //     $(this).removeClass('active')
  // })
  // $(".z2, .z3, .z4, .z5, .z6, .z7, .z8, .z9, .z10").hide("slow")
  // $('.z1').mouseenter(() => {
  //   $(".z2, .z3, .z4, .z5, .z6, .z7, .z8, .z9, .z10").hide("slow")
  // })
  // $('.z1').mouseleave(() => {
  //   $(".z2, .z3, .z4, .z5, .z6, .z7, .z8, .z9, .z10").show("slow")
  // })
  // $('.z2').mouseenter(() => {
  //     $(".z1, .z3, .z4, .z5, .z6, .z7, .z8, .z9, .z10").hide("slow")
  // })
  // $('.z2').mouseleave(() => {
  //   $(".z1, .z3, .z4, .z5, .z6, .z7, .z8, .z9, .z10").show("slow")
  // })
  // $('.z3').mouseenter(() => {
  //   $(".z1, .z2, .z4, .z5, .z6, .z7, .z8, .z9, .z10").hide("slow")
  // })
  // $('.z3').mouseleave(() => {
  //   $(".z1, .z2, .z4, .z5, .z6, .z7, .z8, .z9, .z10").show("slow")
  // })
  // $('.z4').mouseenter(() => {
  //   $(".z1, .z2, .z3, .z5, .z6, .z7, .z8, .z9, .z10").hide("slow")
  // })
  // $('.z4').mouseleave(() => {
  //   $(".z1, .z2, .z3, .z5, .z6, .z7, .z8, .z9, .z10").show("slow")
  // })
  // $('.z5').mouseenter(() => {
  //   $(".z1, .z2, .z3, .z4, .z6, .z7, .z8, .z9, .z10").hide("slow")
  // })
  // $('.z5').mouseleave(() => {
  //   $(".z1, .z2, .z3, .z4, .z6, .z7, .z8, .z9, .z10").show("slow")
  // })
  // $('.z6').mouseenter(() => {
  //   $(".z1, .z2, .z4, .z5, .z3, .z7, .z8, .z9, .z10").hide("slow")
  // })
  // $('.z6').mouseleave(() => {
  //   $(".z1, .z2, .z4, .z5, .z3, .z7, .z8, .z9, .z10").show("slow")
  // })
  // $('.z7').mouseenter(() => {
  //   $(".z1, .z2, .z4, .z5, .z6, .z3, .z8, .z9, .z10").hide("slow")
  // })
  // $('.z7').mouseleave(() => {
  //   $(".z1, .z2, .z4, .z5, .z6, .z3, .z8, .z9, .z10").show("slow")
  // })
  // $('.z8').mouseenter(() => {
  //   $(".z1, .z2, .z4, .z5, .z6, .z7, .z3, .z9, .z10").hide("slow")
  // })
  // $('.z8').mouseleave(() => {
  //   $(".z1, .z2, .z4, .z5, .z6, .z7, .z3, .z9, .z10").show("slow")
  // })
  // $('.z9').mouseenter(() => {
  //   $(".z1, .z2, .z4, .z5, .z6, .z7, .z8, .z3, .z10").hide("slow")
  // })
  // $('.z9').mouseleave(() => {
  //   $(".z1, .z2, .z4, .z5, .z6, .z7, .z8, .z3, .z10").show("slow")
  // })
  // $('.z10').mouseenter(() => {
  //   $(".z1, .z2, .z4, .z5, .z6, .z7, .z8, .z9, .z3").hide("slow")
  // })
  // $('.z10').mouseleave(() => {
  //   $(".z1, .z2, .z4, .z5, .z6, .z7, .z8, .z9, .z3").show("slow")
  // })
})



  return props === undefined ? <div className="loading"></div> : (
    <>
      {/* <div className="homepage">
        <div className="zincGroup">
          <h4 className="namee">ZINC GROUP</h4>

          <div className="homepageImagesDiv">
            <div className="z1 imageAccordingItem">
              <div className="homepageText">
                <h3 className="hoverDisplay">EMBASSY</h3>
              </div>
            </div>
            <div className="z2 imageAccordingItem">
              <div className="homepageText">
                <h3 className="hoverDisplay">MINE</h3>
              </div>
            </div>
            <div className="z3 imageAccordingItem">
              <div className="homepageText">
                <h3 className="hoverDisplay">
                  MAZE
                  <br /> BAR
                </h3>
              </div>
            </div>
            <div className="z4 imageAccordingItem">
              <div className="homepageText">
                <h3 className="hoverDisplay">
                  LOCKHART
                  <br /> 88
                </h3>
              </div>
            </div>
            <div className="z5 imageAccordingItem">
              <div className="homepageText">
                <h3 className="hoverDisplay">PORT</h3>
              </div>
            </div>
            <div className="z6 imageAccordingItem">
              <div className="homepageText">
                <h3 className="hoverDisplay">TABOO</h3>
              </div>
            </div>
            <div className="z7 imageAccordingItem">
              <div className="homepageText">
                <h3 className="hoverDisplay">GRAFFITI</h3>
              </div>
            </div>
            <div className="z8 imageAccordingItem">
              <div className="homepageText">
                <h3 className="hoverDisplay">GATE</h3>
              </div>
            </div>
            <div className="z9 imageAccordingItem">
              <div className="homepageText">
                <h3 className="hoverDisplay">
                  THE <br />
                  STATION
                </h3>
              </div>
            </div>
            <div className="z10 imageAccordingItem">
              <div className="homepageText">
                <h3 className="hoverDisplay">CENTRICO</h3>
              </div>
            </div>
          </div>
        </div>
      </div> */}
      <div className="peopleHappening">
        {/* <People {...props.galleryCategories[2]}/> */}
        <HomepageHappening />
      </div>
      <div className="venue">
        <Venue about={props.store.about_text} />
      </div>
      <div className="gallery">
        <Gallery {...props} />
      </div>
      <div className="footer">
        <Footer />
      </div>
    </>
  );
};

export default Homepage;
